declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', '3208595812653036')
  window.fbq('track', 'PageView')

  // noscript fallback pixel
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=3208595812653036&ev=PageView&noscript=1'
  document.body.appendChild(img)
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
